/* import __COLOCATED_TEMPLATE__ from './profile-info.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { htmlSafe } from '@ember/template';
let ProfileInfo = (_class = class ProfileInfo extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "router", _descriptor, this);
    _initializerDefineProperty(this, "cashLocalProfile", _descriptor2, this);
  }
  onEditProfileClick() {
    this.router.transitionTo('/business/about-my-business');
  }
  get brandName() {
    return this.cashLocalProfile.brandName;
  }
  get profileUrl() {
    return this.cashLocalProfile.profileUrl || '';
  }
  get displayUrl() {
    return this.cashLocalProfile.cleanProfileUrl || '';
  }
  get profileInitials() {
    const name = this.cashLocalProfile.brandName || '';
    const words = name.trim().split(/\s+/);
    if (words.length >= 2) {
      return `${words[0][0]}${words[1][0]}`.toUpperCase();
    } else if (words.length === 1 && words[0].length >= 2) {
      return words[0].slice(0, 2).toUpperCase();
    }
    return words[0];
  }
  get profileIcon() {
    return this.cashLocalProfile.artworkImageLightUrl || '';
  }
  get profileIconBackgroundColorLight() {
    return htmlSafe(`background:${this.cashLocalProfile.backgroundColorLight || '#FFF'};`);
  }
  handleEditProfileClick() {
    this.router.transitionTo('/ordering-profile/settings');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cashLocalProfile", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onEditProfileClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onEditProfileClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleEditProfileClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEditProfileClick"), _class.prototype), _class);
export { ProfileInfo as default };